<nav class="navbar navbar-expand-lg fixed-top bg-light">
    <div class="container-fluid position-relative d-flex align-items-center justify-content-between">

        <!-- Left: Logo -->
        <a class="navbar-brand d-flex align-items-center" href="#" style="font-variant: small-caps; font-size: 1.25em;">
            <img src="{{logo}}" alt="logo" width="100">
        </a>

        <!-- Center: Title (Visible only on desktop) -->
        <span class="fw-bold d-none d-lg-block start-50 translate-middle-x text-center"
              style="font-variant: small-caps; font-size: 1.25em;">
      INVENTORY MANAGEMENT SYSTEM
    </span>

        <!-- Right: User + Toggler -->
        <div class="d-flex align-items-center">
            <button (click)="toggleSidebar()" class="navbar-toggler me-3" type="button">
                <i class="fa fa-bars text-muted"></i>
            </button>
            <ul class="navbar-nav">
                <li class="nav-item dropdown" ngbDropdown>
                    <div *ngIf="userCredentials != null" class="nav-link" ngbDropdownToggle style="cursor: pointer">
                        <i class="fa fa-user"></i>
                        &nbsp;{{ userCredentials.first_name }} {{ userCredentials.last_name }}
                    </div>
                    <div class="dropdown-menu-right header-dropdown" ngbDropdownMenu>
                        <a (click)="open(content);" class="dropdown-item">
                            <i class="fa fa-lock"></i> {{ 'Change Password' | translate }}
                        </a>
                        <a (click)="onLoggedout()" [routerLink]="['/login']" class="dropdown-item">
                            <i class="fa fa-power-off"></i> {{ 'Log Out' | translate }}
                        </a>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <!-- Centered title for mobile view -->
    <a class="navbar-brand d-block d-lg-none text-center w-100 mt-2"
       href="#" style="font-variant: small-caps; font-size: 1.1em;">
        INVENTORY MANAGEMENT SYSTEM
    </a>
</nav>

<ng-template #content let-modal>
  <div class="modal-header ">
    <div class="pull-right text-right">
      <h5 class="modal-title" id="modal-basic-title">
        &nbsp;&nbsp;{{ userCredentials.first_name }}&nbsp;{{ userCredentials.last_name }}
      </h5>
    </div>
    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row col-lg-12">
      <div class="form-group col-lg-12">
        <label>Current Password</label><span class="text-danger">&nbsp;*</span>
        <input [(ngModel)]="current_password" class="form-control " name="confirm_password"
               type="password"
               width="100%">
      </div>
      <div class="form-group col-lg-12">
        <label> New Password</label><span class="text-danger">&nbsp;*</span>
        <input [(ngModel)]="new_password" class="form-control " name="confirm_password" type="password">
      </div>
      <div class="form-group col-lg-12">
        <label> Confirm Password</label><span class="text-danger">&nbsp;*</span>
        <input [(ngModel)]="confirm_password" class="form-control " name="confirm_password"
               type="password">
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="clearfix"></div>
    <div class="clearfix"></div>
    <div class="pull-right">
      <button (click)="changePassword()" class="btn pull-right btn-info btn-sm ng-star-inserted" style="float: center"
              type="button">Change Password
      </button>
    </div>
  </div>
</ng-template>
